<template>
  <div class="col-12 no-content">
    <h3>{{ message }}</h3>
    <b-btn pill variant="primary" class="mt-4" @click="RedirectTo">
      {{ buttonText }}
    </b-btn>
  </div>
</template>

<script>
export default {
  name: "no-content",
  props: {
    buttonText: String,
    message: String,
    isCourse: Boolean,
    isTeacher: Boolean,
    isLive: Boolean
  },
  methods: {
    RedirectTo() {
      if (this.isCourse && !this.isTeacher) this.$router.push("/all_courses");
      else if (this.isLive && !this.isTeacher)
        this.$router.push("/live_courses");
      else if (this.isCourse && this.isTeacher)
        // window.location.replace("https://edfore.techgentsia.com/app/#login");
        this.$router.push("/add_course");
      else this.$router.push("/all_teachers");
    }
  }
};
</script>

<style scoped></style>
